import { createContext } from 'react';

import { WorkflowTracker, WorkflowTrackerKind } from '@/types/schema';

export interface HouseholdWorkflowTrackersContextValue {
  trackers: WorkflowTracker[];
  byId: Record<string, WorkflowTracker>;
  refetch: () => Promise<unknown>;
  loading: boolean;
  /** Set only after a query snapshot or query error commits for this household. */
  snapshotStatus?: { householdID: string; unavailable: boolean };

  /**
   * A map of tracker IDs to their kinds we are awaiting completion for
   */
  awaitingTrackerCompletionByID: Record<string, WorkflowTrackerKind>;
  /**
   * A map of tracker kinds to the IDs of the trackers we are awaiting completion for
   */
  awaitingTrackerCompletionByKind: Partial<
    Record<WorkflowTrackerKind, string[]>
  >;
}

/**
 * Context for subscribing to household-level WorkflowTrackers that we want to "react" to
 * but shouldn't be shown in the activities sidebar. This provides reactivity for functional
 * purposes without the UI interaction capabilities like pagination, dismissal, etc.
 */
export const HouseholdWorkflowTrackersContext = createContext<
  HouseholdWorkflowTrackersContextValue | undefined
>(undefined);
